// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import QuestionMarkCircleFill from "@store/Library/Components/Toolkit/Icons/QuestionMarkCircle/QuestionMarkCircleFill";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface InfoGridProps {
    container?: GridContainerProps;
    item?: GridItemProps;
    largeItem?: GridItemProps;
    largeSubItem?: GridItemProps;
    fullItem?: GridItemProps;
}

export interface InfoProps {
    grid?: InfoGridProps;
    label?: TypographyPresentationProps | TypographyProps;
    value?: TypographyPresentationProps | TypographyProps;
    helpIcon?: IconPresentationProps;
}

export const infoProps: InfoProps = {
    grid: {
        container: {
            gap: 0,
            css: css`
                ${gridGapStyles(pxToRemArray([30]), pxToRemArray([12]))}
                ${spacingStyles()}
            `,
        },
        item: {
            width: [6, 3, 6, 3, 3], // Store Custom Code
            printWidth: 4,
            css: css`
                display: block;
            `,
        },
        largeItem: {
            width: [12, 8, 6, 8, 8],
            printWidth: 8,
            css: css`
                display: block;
            `,
        },
        largeSubItem: {
            width: [12, 6, 12, 6, 6],
            printWidth: 6,
            css: css`
                display: block;
            `,
        },
        fullItem: {
            width: 12,
            css: css`
                display: block;
            `,
        },
    },
    label: {
        variant: null as any,
        as: "h3",
        forwardAs: "h3",
        css: css`
            ${spacingStyles(null, pxToRem(2))}
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    value: {
        variant: null as any,
        as: "span",
        forwardAs: "span",
        css: css`
            display: block;
            word-break: break-word; /* Store Custom Code */
        `,
    },
    helpIcon: {
        src: QuestionMarkCircleFill,
        size: 20,
        css: css`
            margin-left: ${pxToRem(4) /* Store Custom Code */};
            vertical-align: top;
        `,
    },
};
